<p class="picker-label">
  What type of device are you using the Rebooter for?
</p>
<ion-list>
  <ion-item class="ion-activatable" *ngFor="let type of rebooterTypes" (click)="selectType(type)">
    <ion-label>{{type.label}}</ion-label>
    <app-icon *ngIf="isSelected(type.outlet1_type)" name="checkmark" color="primary"></app-icon>
  </ion-item>
</ion-list>
